import request from "@/utils/request";

// 查询流程定义列表
export function getNodeInfo(node) {
  return request({
    url: "/bpmn/getNodeInfo",
    method: "post",
    data: node,
  });
}
